module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/price-config-active.dd2cecd5.svg";